export const POPUP_STEP = {
  select: 'select',
  form: 'form',
};
